import { DISPLAY_CURRENCIES } from './formats.ts';

export const CURRENCY_KEY = '1nl.auditor.currency';
export const FX_CACHE_KEY = '1nl.auditor.fx.v1';

export interface CachedRates {
  base: string;
  rates: Record<string, number>;
  fetchedAt: string;
}

export function loadDisplayCurrency(): string | null {
  try {
    const code = localStorage.getItem(CURRENCY_KEY);
    return DISPLAY_CURRENCIES.some((currency) => currency.code === code) ? code : null;
  } catch {
    return null;
  }
}

export function saveDisplayCurrency(code: string): void {
  try {
    localStorage.setItem(CURRENCY_KEY, code);
  } catch {
    // Storage can be unavailable in privacy-restricted browsers.
  }
}

export function loadCachedRates(): CachedRates | null {
  try {
    const raw = localStorage.getItem(FX_CACHE_KEY);
    if (raw === null) return null;
    const value = JSON.parse(raw) as Partial<CachedRates>;
    if (typeof value.base !== 'string' || typeof value.fetchedAt !== 'string' || value.rates === null || typeof value.rates !== 'object') return null;
    if (Object.values(value.rates).some((rate) => !Number.isFinite(rate) || rate <= 0)) return null;
    return { base: value.base, rates: value.rates, fetchedAt: value.fetchedAt };
  } catch {
    return null;
  }
}

export function saveCachedRates(value: CachedRates): void {
  try {
    localStorage.setItem(FX_CACHE_KEY, JSON.stringify(value));
  } catch {
    // Storage can be unavailable in privacy-restricted browsers.
  }
}
